<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <MainHome/>
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommonApi from "../../services/CommonApi";
import MainHome from "./MainHome.vue";
export default {
  components: {
     MainHome,

},
  data() {
    return {
      doctors: undefined,

      selected_category: undefined,

      search_params: {
        state: "",
        city: "",
        longitude: "",
        lattitude: "",
        complaints: "",
        healthcare_sub_category: "",
        gender: "",
        practitioner_speciality: "",
        healthcare_category: "",
      },
    };
  },

  mounted() {},
  watch: {
    search_params: {
      deep: true,
      handler() {
        this.filter_search_category();
      },
    },
  },
  methods: {
    set_search_state(param) {
      this.search_params.state = param;
    },
    set_search_city(param) {
      this.search_params.city = param;
    },
    set_search_lattitude(param) {
      this.search_params.lattitude = param;
    },
    set_search_longitude(param) {
      this.search_params.longitude = param;
    },

    set_search_complaints(param) {
      this.search_params.complaints = param;
    },
    set_updated_category(param) {
      this.selected_category = param;
      this.search_params.healthcare_category = param;
    },
    set_search_sub_category(param) {
      console.log("hiding sub category");
      this.search_params.healthcare_sub_category = param;
    },
    set_search_gender(param) {
      this.search_params.gender = param;
      this.get_doctors();
    },
    set_search_speciality(param) {
      this.search_params.practitioner_speciality = param;
      this.get_doctors();
    },
    async get_doctors() {
      let search = new URLSearchParams(this.search_params);
      await CommonApi.get_data("sahaj.finalapi.get_doctor_list", search).then(
        (res) => {
          this.doctors = res.data;
        }
      );
    },

    update_sub_category(data) {
      this.selected_category = data;
      this.search_params.healthcare_category = data;
      if (data == undefined) {
        this.search_params.healthcare_sub_category = "";
      }
    },
    filter_search_category() {
      this.get_doctors();
    },
  },
};
</script>

<style>
.main-wrapper {
  height: 100% !important;
  min-height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/Index.vue